// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1tLgZ","productName":"Table_productName__2LYRC"};